import { render } from "./SwdMemberActions.vue?vue&type=template&id=f4f8c898"
import script from "./SwdMemberActions.vue?vue&type=script&lang=js"
export * from "./SwdMemberActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__